export const APP_CONST = {
  /** App mannually checks for updates every(ms): ... */
  updateCheckDelay: 600000,
  /** The action to **return to top** should appear once scrolled(px): ... */
  scrollToTopOffset: 400,
  /** Delay in ms in wich a notification will be dismissed: */
  notificationDuration: 5000,
  /** Default message to show when an error ocurred. Ex. on api request failed */
  defaultErrorMessage: 'Ocurrió un error. Por favor, intente nuevamente.',
};
